import { css } from '@eti/styles';
import { vars } from '@etg/wings';
import { jsx as _jsx } from "react/jsx-runtime";
const colors = {
  hint: vars.colors.signal.information.foreground,
  error: vars.colors.signal.critical.foreground,
  warning: vars.colors.text.primary
};
const textStyles = type => css`
  color: ${colors[type] || 'inherit'};
  font-size: 0.875rem;
  margin-block-start: 6px;
  margin-inline-start: 8px;
`;
const Message = ({
  error,
  hint,
  warning
}) => {
  if (hint) {
    return /*#__PURE__*/_jsx("div", {
      className: textStyles('hint'),
      children: hint
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx("div", {
      className: textStyles('error'),
      children: error
    });
  }
  if (warning) {
    return /*#__PURE__*/_jsx("div", {
      className: textStyles('warning'),
      children: warning
    });
  }
  return null;
};
export default Message;
//# sourceMappingURL=Message.js.map